import React from "react";
import InputPadraoProduto from "../../ui/Cliente/InputCliente";

export default function DadosCliente({ dados, setDados }) {
  const handleChange = (campo, valor) => {
    setDados({ ...dados, [campo]: valor });
  };

  return (
    <div className="space-y-10">
      <div className="flex items-center gap-3 mb-8">
        <h2
          className="font-semibold"
          style={{
            fontFamily: "Comfortaa, cursive",
            fontSize: "16px",
            color: "#454545",
          }}
        >
          Dados do Cliente
        </h2>
        <div
          className="flex-1 h-[2px] rounded-full"
          style={{ backgroundColor: "#454545", opacity: 0.9 }}
        />
      </div>

      {/* Primeira linha */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-end">
        <InputPadraoProduto
          value={dados.nomeFantasia}
          onChange={(e) => handleChange("nomeFantasia", e.target.value)}
          placeholder="Nome Fantasia"
        />
        <InputPadraoProduto
          value={dados.razaoSocial}
          onChange={(e) => handleChange("razaoSocial", e.target.value)}
          placeholder="Razão Social"
        />
        <div className="md:w-[80%]">
          <InputPadraoProduto
            value={dados.cpfCnpj}
            onChange={(e) => handleChange("cpfCnpj", e.target.value)}
            placeholder="CPF/CNPJ"
          />
        </div>
      </div>

      {/* Segunda linha */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-end mt-6">
        <div className="md:col-span-2">
          <InputPadraoProduto
            type="email"
            value={dados.email}
            onChange={(e) => handleChange("email", e.target.value)}
            placeholder="E-mail"
          />
        </div>
        <div className="md:col-span-1 md:w-[80%]">
          <InputPadraoProduto
            type="tel"
            value={dados.telefone}
            onChange={(e) => handleChange("telefone", e.target.value)}
            placeholder="Telefone"
          />
        </div>
      </div>
    </div>
  );
}
